export function ShoeDepth({ remaining, total }) {
  const pct = total > 0 ? (remaining / total) * 100 : 0;
  return (
    <div className="mb-6" data-testid="shoe-depth">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Shoe Depth</span>
        <span className="text-xs font-bold tabular-nums" data-testid="shoe-depth-label">
          {remaining}/{total} · {Math.round(pct)}%
        </span>
      </div>
      <div className="h-2.5 border-2 border-foreground bg-card overflow-hidden">
        <div
          className="h-full bg-foreground transition-[width] duration-150"
          style={{ width: `${pct}%` }}
          data-testid="shoe-depth-bar"
        />
      </div>
    </div>
  );
}
